import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaBlog, FaCheckCircle } from 'react-icons/fa';

const Contact = () => {
  const availableFor = [
    'Senior Backend Roles',
    'Laravel Architecture Consulting',
    'Freelance SaaS Development',
    'API Development',
  ];

  const contactInfo = [
    {
      icon: FaEnvelope,
      title: 'Email',
      value: 'shalender8928@yahoo.com',
      link: 'mailto:shalender8928@yahoo.com'
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Location',
      value: 'Ludhiana, Punjab, India',
      link: null
    }
  ];

  const socialLinks = [
    {
      icon: FaLinkedin,
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/shalender8928/',
      color: 'text-blue-600 hover:text-blue-700'
    },
    {
      icon: FaBlog,
      name: 'Technical Blog',
      url: 'https://codinghelpsolutions.com',
      color: 'text-gray-600 hover:text-gray-700'
    }
  ];

  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4">
            Get In Touch
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            I'm always interested in new opportunities and challenging projects. 
            Let's discuss how we can work together!
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Let's Start a Conversation
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                With over 10 years of experience in web development, I'm passionate about 
                creating innovative solutions and would love to hear about your project needs.
              </p>
            </div>

            {/* Contact Details */}
            <div className="space-y-6">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <info.icon className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">
                      {info.title}
                    </h4>
                    {info.link ? (
                      <a
                        href={info.link}
                        className="text-blue-600 hover:text-blue-700 transition-colors"
                      >
                        {info.value}
                      </a>
                    ) : (
                      <p className="text-gray-600">{info.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-4">
                Connect With Me
              </h4>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-12 h-12 bg-white rounded-lg shadow-md flex items-center justify-center ${social.color} hover:-translate-y-2 transition-all duration-300`}
                    title={social.name}
                  >
                    <social.icon className="text-xl" />
                  </a>
                ))}
              </div>
            </div>

            
          </motion.div>

          {/* Call to Action */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <div className="bg-blue-600 p-8 md:p-10 rounded-xl text-white space-y-7 shadow-md">
              <h3 className="text-2xl font-bold mb-4">
                Ready to Start Your Project?
              </h3>
              <p className="text-blue-100 text-lg max-w-2xl mx-auto leading-relaxed">
                I'm available for freelance projects and full-time opportunities. 
                Let's discuss how I can help bring your ideas to life.
              </p>

              <div className="bg-white/10 border border-white/20 rounded-lg p-5 md:p-6 text-left">
                <h4 className="text-xl font-semibold mb-4">Available For</h4>
                <div className="grid sm:grid-cols-2 gap-3">
                  {availableFor.map((item) => (
                    <div key={item} className="flex items-start gap-2.5">
                      <FaCheckCircle className="text-emerald-300 mt-1 flex-shrink-0" />
                      <span className="text-blue-50">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="mailto:shalender8928@yahoo.com"
                  className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold transition-colors duration-300"
                >
                  Email Me Directly
                </a>
                <a
                  href="https://www.linkedin.com/in/shalender8928/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                >
                  Connect on LinkedIn
                </a>
              </div>
            </div>

          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
